/**
 * @generated SignedSource<<fce8a25272275dea5a784579ba50e4fe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Conversation_participant",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "shortId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "associationId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "associationType",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SignUpInput_participant"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ChatInput_participant"
    }
  ],
  "type": "Participant",
  "abstractKey": null
};

node.hash = "aa971659a0570a0a6ab33e11a861d473";

module.exports = node;
